/**
 * چند ردیفِ واقعی از یک وضعیت.
 *
 * جمع‌شده باز می‌شود و نه همیشه باز: صفحه چهار ریزش دارد و اگر هر کدام پنج
 * ردیف نشان می‌داد، نمودار و جدولِ فازها از صفحه بیرون می‌افتادند. عدد اول
 * دیده می‌شود، نمونه وقتی که لازم شد.
 *
 * شکلِ ردیف‌ها از وضعیتی به وضعیت دیگر فرق می‌کند (صفحه، رخداد، هشدار…) پس
 * ستون‌ها از خودِ داده ساخته می‌شوند، نه از یک فهرستِ ثابت.
 */
import React, { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { opsRepo, type SampleKind } from '@/core/data/opsRepo';

const cell = (v: unknown): string => {
  if (v == null) return '';
  if (typeof v === 'string' && /^\d{4}-\d{2}-\d{2}T/.test(v)) {
    return new Date(v).toLocaleString('en-CA', { dateStyle: 'short', timeStyle: 'short' });
  }
  return typeof v === 'object' ? JSON.stringify(v) : String(v);
};

export function Samples({ kind, limit = 5 }: { kind: SampleKind; limit?: number }) {
  const [open, setOpen] = useState(false);
  const rows = useQuery({
    queryKey: ['sample', kind, limit],
    queryFn: () => opsRepo.samples(kind, limit),
    enabled: open,
  });

  if (!open) {
    return (
      <button type="button" className="tab" onClick={() => setOpen(true)}>
        نمونه ببین
      </button>
    );
  }

  if (rows.isLoading) return <p className="dim">…</p>;
  if (rows.error) return <p className="err">{String(rows.error)}</p>;

  const data = rows.data ?? [];
  if (!data.length) return <p className="dim">نمونه‌ای نبود.</p>;

  const cols = Object.keys(data[0]);

  return (
    <div className="scrollx">
      <table className="tbl">
        <thead>
          <tr>{cols.map((c) => <th key={c}>{c}</th>)}</tr>
        </thead>
        <tbody>
          {data.map((r, i) => (
            // شناسه‌ی پایداری در کار نیست و فهرست هم هرگز مرتب/فیلتر نمی‌شود،
            // پس ایندکس این‌جا بی‌خطر است.
            <tr key={i}>
              {cols.map((c) => (
                <td key={c} className="mono">{cell((r as Record<string, unknown>)[c])}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
